import { PageDoesntExist } from "@/pageDoesntExist";
import AuthRoleWrapper from "../AuthRoleWrapper";
import SubmissionsPage from "@/pages/Submissions/SubmissionsPage";
import { siteRoutes } from "../siteRoutesList";
import AnalyticsPage from "@/pages/Analytics/Analytics";

export const adminRoutes = [
  // Analytics
  {
    element: () => AuthRoleWrapper({ Component: AnalyticsPage }),
    path: siteRoutes["analytics"], // route to news overview
  },
  // Submissions
  {
    element: () => AuthRoleWrapper({ Component: SubmissionsPage }),
    path: siteRoutes["submissions"], // route to news overview
  },
];
